export default {
    SAVE_QUOTATION_INFO: 'QUOTATION/SAVE_QUOTATION_INFO',
    SAVE_UPDATE_PARAMS: 'QUOTATION/SAVE_UPDATE_PARAMS',
}


// WEBPACK FOOTER //
// ./src/components/quotation/store/constants.js